<template>

    <v-layout fill-height>
      <v-flex >
        <v-layout column fill-height>
          <scroll-area>
            <template slot="body">
              <v-layout column  justify-start class="pa-2">
                
                <v-layout justify-start>
                  <v-flex xs3 pr-1>
                    <v-layout justify-center>
                      Параметр
                    </v-layout>
                    
                  </v-flex>
                  <v-flex xs3 pr-1>
                    <v-layout justify-center>
                      Тревога
                    </v-layout>
                    <!-- Тревога -->
                  </v-flex>
                  <v-flex xs3 pr-1>
                    <v-layout justify-center>
                      Предупреждение
                    </v-layout>
                    <!-- Предупреждение -->
                  </v-flex>
                  <v-flex xs3 pr-1>
                    <v-layout justify-center>
                      Нормальное
                    </v-layout>
                    <!-- Нормальное -->
                  </v-flex>
                </v-layout>

                <div v-for="(field, name) in getFields" :key="name">

                  <v-layout justify-start  pt-1>
                    <v-flex xs3 pr-1 >
                      {{ field.name }}
                    </v-flex>
                    <v-flex xs3 pr-1 >

                      <v-layout justify-start>
                        <v-flex xs6  pa-0>
                          <v-text-field 
                            :value="$t('expression')"
                            light
                            outline
                            flat
                            readonly
                            disabled
                            class="backgrey"
                            hide-details
                            :rows="1"
                            color="white"
                          >                   
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12  pa-0>                          
                          <v-text-field
                            :data-testid="$options.name + '__expression_text-field__' + field.name"
                            v-model="field.alarmRule.expression"
                            light                   
                            outline
                            :readonly="true"
                            class="white"                         
                            hide-details
                            :rows="1"
                            color="accent"
                          >                     
                          </v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-start pt-1>
                        <v-flex xs6  pa-0>
                          <v-text-field 
                            :value="$t('message')"
                            light
                            outline
                            flat
                            readonly
                            disabled
                            class="backgrey"
                            hide-details
                            :rows="1"
                            color="white"
                          >                   
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12  pa-0>                          
                          <v-text-field
                            :data-testid="$options.name + '__message_text-field__' + field.name"
                            v-model="field.alarmRule.message"
                            light                   
                            outline
                            :readonly="true"
                            class="white"                         
                            hide-details
                            :rows="1"
                            color="accent"
                          >                     
                          </v-text-field>
                        </v-flex>
                      </v-layout>

                    </v-flex>
                    <v-flex xs3 pr-1 >
                      <v-layout justify-start>
                        <v-flex xs6  pa-0>
                          <v-text-field 
                            :value="$t('expression')"
                            light
                            outline
                            flat
                            readonly
                            disabled
                            class="backgrey"
                            hide-details
                            :rows="1"
                            color="white"
                          >                   
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12  pa-0>                          
                          <v-text-field
                            :data-testid="$options.name + '__expression_text-field__' + field.name"
                            v-model="field.warnRule.expression"
                            light                   
                            outline
                            :readonly="true"
                            class="white"                         
                            hide-details
                            :rows="1"
                            color="accent"
                          >                     
                          </v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-start pt-1>
                        <v-flex xs6  pa-0>
                          <v-text-field 
                            :value="$t('message')"
                            light
                            outline
                            flat
                            readonly
                            disabled
                            class="backgrey"
                            hide-details
                            :rows="1"
                            color="white"
                          >                   
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12  pa-0>                          
                          <v-text-field
                            :data-testid="$options.name + '__message_text-field__' + field.name"
                            v-model="field.warnRule.message"
                            light                   
                            outline
                            :readonly="true"
                            class="white"                         
                            hide-details
                            :rows="1"
                            color="accent"
                          >                     
                          </v-text-field>
                        </v-flex>
                      </v-layout>

                    </v-flex>
                    <v-flex xs3 pr-1 >
                      <v-layout justify-start>
                        <v-flex xs6  pa-0>
                          <v-text-field 
                            :value="$t('expression')"
                            light
                            outline
                            flat
                            readonly
                            disabled
                            class="backgrey"
                            hide-details
                            :rows="1"
                            color="white"
                          >                   
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12  pa-0>                          
                          <v-text-field
                            :data-testid="$options.name + '__expression_text-field__' + field.name"
                            v-model="field.okRule.expression"
                            light                   
                            outline
                            :readonly="true"
                            class="white"                         
                            hide-details
                            :rows="1"
                            color="accent"
                          >                     
                          </v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-start pt-1>
                        <v-flex xs6  pa-0>
                          <v-text-field 
                            :value="$t('message')"
                            light
                            outline
                            flat
                            readonly
                            disabled
                            class="backgrey"
                            hide-details
                            :rows="1"
                            color="white"
                          >                   
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12  pa-0>                          
                          <v-text-field
                            :data-testid="$options.name + '__message_text-field__' + field.name"
                            v-model="field.okRule.message"
                            light                   
                            outline
                            :readonly="true"
                            class="white"                         
                            hide-details
                            :rows="1"
                            color="accent"
                          >                     
                          </v-text-field>
                        </v-flex>
                      </v-layout>

                    </v-flex>
                  </v-layout>

                </div>
              </v-layout>
            </template>

            <template slot="footer">
              <v-layout fill-height>
                <v-flex xs2>
                  <v-btn small 
                  :data-testid="$options.name + '__btn__' + 'confirmAndReload'"
                  @click="confirmAndReload" color="secondary">{{ $t('roll back') }}</v-btn>
                </v-flex>

                <v-layout fill-height justify-end>
                  <v-btn dark small 
                  :data-testid="$options.name + '__btn__' + 'close'"
                  @click="()=>{$emit('close')}" color="secondary">{{$t('cancel')}}</v-btn>
                  <v-btn small 
                  :data-testid="$options.name + '__btn__' + 'confirmAndSave'"
                  @click="confirmAndSave" color="success" >{{$t('save')}}</v-btn>
                </v-layout>
              </v-layout>
            </template>

          </scroll-area>
        </v-layout>
      </v-flex>
    </v-layout>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'

// Типы
interface RuleItem {
  expression: string
  message: string
}

interface RowData {
  [key: string]: RuleItem[]
}

interface ModelData {
  fields: Record<string, any>
}

interface MetaItem {
  id: string
  [key: string]: any
}

interface RowProps {
  $id?: string
  source_id?: string
  measure_id?: string
  bridge?: string
  [key: string]: any
}

interface MetricItem {
  id: string
  [key: string]: any
}

interface BridgeItem {
  metrics?: MetricItem[]
  [key: string]: any
}

interface TemplateItem {
  id: string
  bridges?: Record<string, BridgeItem>
  [key: string]: any
}

export default Vue.extend({
  name: 'SERVICE_SETTINGS',

  components: {
    scrollArea,
  },

  props: {
    row: {
      type: Object as () => RowProps,
      required: true,
      default: () => ({})
    },
    refId: {
      type: String,
      default: ''
    }
  },

  data(): {
    rowData: RowData
    err: string
    meta: MetaItem | null
    model: ModelData
  } {
    return {
      rowData: [],
      err: '',
      meta: null,
      model: {
        fields: {},
      },
    }
  },

  computed: {
    getFields(): Record<string, any> {
      return this.model.fields
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(caller?: string): Promise<void> {
      this.loadMeta()
    },

    async loadMeta(caller?: string): Promise<void> {
      try {
        const meta = await this.$bridge.getTemplates('custom') as MetaItem[]
        if (meta?.length) {
          const template = meta.find(item => item.id === 'Vinteo user')
          if (template) {
            this.meta = template
            if (this.meta) {
              this.model = await this.$prepareMeta(this.meta, this.$options.name)
            }
          }
        }
      } catch (err) {
        console.error('CATCH', 'SERVICE_SETTINGS', 'loadMeta', err)
      }
    },

    fillData(): void {
      const safeJSONParse = (entry: [string, any]): RuleItem[] => {
        const value = entry[1]
        if (typeof value === 'string' && value.length > 0 && value[0] !== '[') {
          this.err = `${this.$getTranslate('in field')} ${entry[0]} ${this.$getTranslate('an error has been fixed, please follow the rules')}`
          return [{ expression: value, message: '' }]
        }
        return JSON.parse(value || '[]')
      }

      const filtered = Object.entries(this.row).filter(
        e => e[0].length > 5 && e[0].substr(e[0].length - 5) === '_rule'
      )
      const parsed = filtered.map(e => [e[0], e[1] != null ? safeJSONParse(e) : []])
      this.rowData = Object.fromEntries(parsed)
    },

    removeRuleRow(name: string, expr: string): void {
      this.$dialog.confirm({
        text: 'Удалить выражение?',
        title: 'Удаление',
        actions: {
          false: 'Отмена',
          true: {
            color: 'red',
            text: 'Удалить',
            handle: () => {
              this.rowData[name] = this.rowData[name].filter(l => l.expression !== expr)
            }
          }
        }
      })
    },

    async saveData(): Promise<void> {
      const obj = await this.$bridge.getObjectById(this.row.$id)
      const d = Object.entries(this.rowData)
      const newRules = Object.fromEntries(d.map(e => [e[0], JSON.stringify(e[1])]))

      try {
        const u$ = await obj.update(newRules)
        if (u$) {
          this.$emit('polling')
        }
        console.log('OBJ', obj)
        console.log('NEW RULES', newRules)
        console.log('RULE UPDATE', u$)
        await this.$store.dispatch('loadMeasures', this.row.source_id)
      } catch (err) {
        this.$errorHandler(err)
      } finally {
        this.$emit('updateMeasures')
        this.$emit('close')
      }
    },

    async confirmAndSave(): Promise<void> {
      await this.$dialog.confirm({
        text: 'Сохранить данные?',
        title: 'Сохранение',
        actions: {
          false: 'Отмена',
          true: {
            color: 'green',
            text: 'Сохранить',
            handle: this.saveData
          }
        }
      })
    },

    async reloadDeviceData(): Promise<void> {
      const activeDevice = this.$store.state.devices.activeDevice as RowProps
      const templ = activeDevice?.template
      const templates = await this.$bridge.getTemplates('device') as TemplateItem[]
      const d = templates.filter(t => t.id === templ)[0]

      if (d?.bridges) {
        const funcFind = (metric: MetricItem): boolean => {
          const ref_id = this.refId
          return eval('`' + metric.id + '`') === this.row.measure_id
        }

        const bridge = d.bridges[this.row.bridge as string]
        if (bridge?.metrics) {
          bridge.metrics.forEach(item => {
            const m = item.metrics?.find(funcFind)
            if (m !== undefined) {
              let rules = Object.entries(m).filter(o => o[0].substr(o[0].length - 4) === 'Rule')
              rules = rules.map(r => [r[0].replace('Rule', '_rule'), r[1]])
              const rulesObj = Object.fromEntries(rules)
              
              Object.keys(this.rowData).forEach(key => {
                this.rowData[key] = rulesObj[key] || []
              })
            }
          })
        }
      }
    },

    async confirmAndReload(): Promise<void> {
      await this.$dialog.confirm({
        text: 'Вернуть настройки к значениям по умолчанию?',
        title: 'Подтверждение',
        actions: {
          false: 'Отмена',
          true: {
            color: 'green',
            text: 'Сбросить',
            handle: this.reloadDeviceData
          }
        }
      })
    },
  },
})
</script>

<style lang="stylus" scoped>
.rule
  border 1px solid #c1c163
  margin-bottom: 5px;
  padding: 5px;
.rule-item
  //border 1px solid red
  display flex
  justify-content stretch
  align-items baseline
  .field
    margin 0 3px
    outline: darkgray solid 1px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    background-color: white;
.v-btn.supersmall
  padding-top: 4px
  height: 24px
  width: 24px
  right: 5px
</style>
